(() => {
  window.jigSetCommunityMedia = (root, entries) => {
    const tags = (root.dataset.productTags || '').split(',').map(tag => tag.trim()).filter(Boolean);
    const container = root.querySelector('[data-community-items]');
    if (!container) return;
    const matching = (Array.isArray(entries) ? entries : []).filter(entry => Array.isArray(entry?.productTags) && entry.productTags.some(tag => tags.includes(tag)) && entry.source && entry.creator);
    const cards = matching.flatMap(entry => {
      let url;
      try { url = new URL(entry.href); } catch { return []; }
      if (url.protocol !== 'https:') return [];
      const card = document.createElement('article');
      const title = document.createElement('h3'); title.textContent = entry.title || '';
      const source = document.createElement('p'); source.textContent = [root.dataset.communityLabel, entry.source, entry.creator].join(' · ');
      const description = document.createElement('p'); description.textContent = entry.description || '';
      const link = document.createElement('a'); link.textContent = root.dataset.originalLabel; link.href = url.href; link.target = '_blank'; link.rel = 'noopener noreferrer';
      card.append(source, title, description, link);
      return [card];
    });
    if (cards.length) container.replaceChildren(...cards);
    else {
      const empty = document.createElement('p'); empty.textContent = root.dataset.emptyLabel; container.replaceChildren(empty);
    }
  };
  const init = scope => {
    scope.querySelectorAll('.jig-product-media').forEach(root => {
      if (root.dataset.resourcesReady) return;
      root.dataset.resourcesReady = 'true';
      const tabs = [...root.querySelectorAll('[data-resource-tab]')];
      tabs.forEach((tab, tabIndex) => {
        const select = () => tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1;
          root.querySelector('[data-resource-panel="' + item.dataset.resourceTab + '"]').hidden = !active;
        });
        tab.addEventListener('click', select);
        tab.addEventListener('keydown', event => {
          const next = { ArrowRight: (tabIndex + 1) % tabs.length, ArrowLeft: (tabIndex + tabs.length - 1) % tabs.length, Home: 0, End: tabs.length - 1 }[event.key];
          if (next === undefined) return;
          event.preventDefault(); tabs[next].click(); tabs[next].focus();
        });
      });
      window.jigSetCommunityMedia(root, []);
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
